export default "/images/avatar.svg?ea448c20f0d954d9af12496c7b90ea33";